import $ from 'jquery';
import template from './default-template.hbs';

const $template = $.templates(template);

export default {
  selectors: {
    btnPrev: '.btn_prev',
    btnNext: '.btn_next',
    playList: '.list_vclip',
    items: '[data-vid]'
  },
  classNames: {
    off: 'btn_off'
  },
  itemsInPage: 4,
  initialPage: 1,
  render(templateData) {
    return $template.render(templateData);
  }
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/video-playlist/default-configs.js
 **/